import React, { useState } from "react";
import InputSelectFilterManager from "../InputSelectFilterManager";
import Input from "../Input";
import uploadFileIcon from "../../images/svg/uploadFileIcon.svg";
import deleteImageIcon from "../../images/svg/deleteImageIcon.svg";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../services/api";
import { useEffect } from "react";
import app from "../../firebase/database";
import Textarea from "../Textarea";
import { useTranslation } from "react-i18next";

const TableListEditStock = () => {
  const { t } = useTranslation();

  const [editInventory, setEditInventory] = useState(false);

  const [imagesBase64, setImagesBase64] = useState([]);
  const [imagesFirebase, setImagesFirebase] = useState([]);
  const [unitaryValue, setUnitaryValue] = useState(0);

  const [typeCount, setTypeCount] = useState();
  const [cliet, setClient] = useState();
  const [deposit, setDeposit] = useState();

  const [description, setDescription] = useState();
  const [product, setProduct] = useState();
  const [series, setSeries] = useState();

  const [validate, setValidate] = useState();
  const [productCode, setProductCode] = useState();
  const [manufacture, setManufacture] = useState();

  const [typeStructure, setTypeStructure] = useState();
  const [temperature, setTemperature] = useState();
  const [address, setAddress] = useState();

  const [initialValue, setInitialValue] = useState();
  const [batch, setBatch] = useState();
  const [reasons, setReasons] = useState();

  const [comentarys, setComentarys] = useState();
  const [updateState, setUpdateState] = useState(false);
  const [quantity, setQuantity] = useState(0);

  const getImages = (file) => {
    if (imagesBase64.length == 6) {
      toast.error("Limite de imagens atingido!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return false;
    }

    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const array = [...imagesBase64];

      array.push({ image: reader.result });

      setImagesBase64(array);
    };

    const images = [...imagesFirebase];
    images.push({ image: file });
    setImagesFirebase(images);
  };
  const removeImage = (image, imageData) => {
    const array = imagesBase64.slice();
    let index = 0;

    array.map((item, i) => {
      if (item?.image && item.image === image) {
        index = i;
      } else if (item === imageData) {
        index = i;
      }
    });
    array.splice(index, 1);

    setImagesBase64(array);

    /* const array = imagesBase64.slice()
         array.splice(imagesBase64.indexOf(image), 1)
         setImagesBase64(array)
 
         const arrayFirebase = imagesFirebase.slice()
         arrayFirebase.splice(imagesFirebase.indexOf(image), 1)
         setImagesFirebase(array)*/
  };
  const get = async () => {
    const response = await api.get(
      `/countage/by/id/${localStorage.getItem("@ID_EDIT_STOCK")}`
    );

    console.log(response.data[0]);

    setTypeCount(response.data[0].typeCount);
    setClient(response.data[0].client);
    setDeposit(response.data[0].deposit);

    setDescription(response.data[0].description);
    setProduct(response.data[0].product);
    setBatch(response.data[0].batch);

    setSeries(response.data[0].series);
    setValidate(response.data[0].validate);
    setProductCode(response.data[0].productCode);
    setManufacture(response.data[0].manufacture);
    setTypeStructure(response.data[0].typeStructure);

    setTemperature(response.data[0].temperature);

    setAddress(response.data[0].address);
    setUnitaryValue(response.data[0].unitaryValue);
    setInitialValue(response.data[0].initialValue);

    setReasons(response.data[0].reasonErrors);
    setComentarys(response.data[0].comments);

    if (
      response.data[0].primaryValue &&
      !response.data[0].secondaryValue &&
      !response.data[0].threeValue &&
      !response.data[0].fourValue
    ) {
      setQuantity(response.data[0].primaryValue);
    }

    if (
      response.data[0].secondaryValue &&
      !response.data[0].threeValue &&
      !response.data[0].fourValue
    ) {
      setQuantity(response.data[0].secondaryValue);
    }

    if (response.data[0].threeValue && !response.data[0].fourValue) {
      setQuantity(response.data[0].threeValue);
    }

    if (response.data[0].fourValue) {
      setQuantity(response.data[0].fourValue);
    }

    const list = [
      response.data[0].picture1,
      response.data[0].picture2,
      response.data[0].picture3,
      response.data[0].picture4,
      response.data[0].picture5,
    ];
    const newList = [];

    list.map((item) => {
      if (item) {
        newList.push(item);
      }
    });

    setImagesBase64(newList);

    if (!editInventory) {
      setQuantity("");
    }
  };
  const update = async () => {
    toast.info("Alterando dados...!", {
      position: "top-right",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    const array = [];

    if (imagesBase64.length > 0) {
      imagesBase64.map((item) => {
        if (typeof item == "string") {
          array.push(item);
        }
      });

      imagesFirebase.map(async (item) => {
        await app
          .storage()
          .ref(`/product/images/${item.image.name}`)
          .put(item.image)
          .then(() => {
            app
              .storage()
              .ref(`/product/images/${item.image.name}`)
              .getDownloadURL()
              .then(async (url) => {
                array.push(url);

                await api.put("countage/image", {
                  picture1: array[0] ? array[0] : null,
                  picture2: array[1] ? array[1] : null,
                  picture3: array[2] ? array[2] : null,
                  picture4: array[3] ? array[3] : null,
                  picture5: array[4] ? array[4] : null,
                  picture6: array[5] ? array[5] : null,
                  reasonErrors: reasons,
                  id: localStorage.getItem("@ID_EDIT_STOCK"),
                });
              });
          });

        /*await api.put("countage", {
                    "picture1": array[0] ? array[0] : null,
                    "picture2": array[1] ? array[1] : null,
                    "picture3": array[2] ? array[2] : null,
                    "picture4": array[3] ? array[3] : null,
                    "picture5": array[4] ? array[4] : null,
                    "picture6": array[5] ? array[5] : null,
                    "reasonErrors": reasons,
                    "id": localStorage.getItem("@ID_EDIT_STOCK")
                })*/
      });
    }

    if (editInventory) {
      const response = await api.put("countage", {
        typeCount: typeCount,
        client: cliet,
        deposit: deposit,
        description: description,
        deposit: deposit,
        product: product,
        batch: batch,
        series: series,
        validate: validate,
        productCode: productCode,
        manufacture: manufacture,
        typeStructure: typeStructure,
        temperature: temperature,
        address: address,
        unitaryValue: unitaryValue,
        initialValue: initialValue,
        comments: comentarys,
        picture1: (array[0] && array[0]) || null,
        picture2: (array[1] && array[1]) || null,
        picture3: (array[2] && array[2]) || null,
        picture4: (array[3] && array[3]) || null,
        picture5: (array[4] && array[4]) || null,
        picture6: (array[5] && array[5]) || null,
        reasonErrors: reasons,
        quantity: quantity || 0,

        id: localStorage.getItem("@ID_EDIT_STOCK"),
      });

      if (response.status == 200) {
        setTimeout(() => {
          toast.success("Dados alterados com sucesso!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }, 1500);

        setTimeout(() => {
          if (window.location.pathname == "/dashboard/edit/stock/inventory") {
            return (window.location.href = "/dashboard/inventary");
          }
          window.location.href = "/dashboard/manager";
        }, [3500]);
      }
    }

    if (!editInventory) {
      const response = await api.put("countage", {
        typeCount: typeCount,
        client: cliet,
        deposit: deposit,
        description: description,
        deposit: deposit,
        product: product,
        batch: batch,
        series: series,
        validate: validate,
        productCode: productCode,
        manufacture: manufacture,
        typeStructure: typeStructure,
        temperature: temperature,
        address: address,
        unitaryValue: unitaryValue,
        initialValue: initialValue,
        comments: comentarys,
        picture1: (array[0] && array[0]) || null,
        picture2: (array[1] && array[1]) || null,
        picture3: (array[2] && array[2]) || null,
        picture4: (array[3] && array[3]) || null,
        picture5: (array[4] && array[4]) || null,
        picture6: (array[5] && array[5]) || null,
        reasonErrors: reasons,

        id: localStorage.getItem("@ID_EDIT_STOCK"),
      });

      if (typeof Number(quantity) == "number") {
        const idCount = localStorage.getItem("@ID_EDIT_STOCK");
        const responseCount = await api.post(`countage/details/${idCount}`, {
          quantity: quantity || 0,
        });
        if (responseCount.status == 200) {
          setTimeout(() => {
            toast.success("Dados alterados com sucesso!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }, 1500);

          setTimeout(() => {
            if (window.location.pathname == "/dashboard/edit/stock/inventory") {
              return (window.location.href = "/dashboard/inventary");
            }
            window.location.href = "/dashboard/manager";
          }, [3500]);
        }
      }

      if (typeof Number(quantity) != "number") {
        if (response.status == 200) {
          setTimeout(() => {
            toast.success("Dados alterados com sucesso!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }, 1500);

          setTimeout(() => {
            if (window.location.pathname == "/dashboard/edit/stock/inventory") {
              return (window.location.href = "/dashboard/inventary");
            }
            window.location.href = "/dashboard/manager";
          }, [3500]);
        }
      }
    }
  };

  const styleColum1 = {
    width: "100%",
    border: "1px solid #D7D7D7",
    borderRadius: "10px",
    paddingLeft: "21px",
    paddingTop: "25px",
    background: "white",
  };
  const styleColum2 = {
    marginTop: "2.93rem",
    height: "540px",
    width: "100%",
    border: "1px solid #D7D7D7",
    borderRadius: "10px",
    paddingLeft: "21px",
    paddingTop: "25px",
    background: "white",
    overflowY: "auto",
  };
  const styleRowInputs = {
    display: "flex",
    width: "100%",
  };
  const btnStyle = {
    width: "165px",
    height: "45px",
    borderRadius: "60px",
    background: "#123164",
    border: "none",
    marginTop: "2.18rem",
    marginBottom: "2.18rem",

    outline: "none",
  };

  useEffect(() => {
    const editInventory = localStorage.getItem("@ID_EDIT_INVENTORY");

    console.log(editInventory);

    if (editInventory) {
      setEditInventory(true);
    }

    get();
  }, []);

  useEffect(() => {
    if (updateState == true) {
      localStorage.removeItem("@ID_EDIT_INVENTORY");

      toast.success("Dados alterados com sucesso!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      setTimeout(() => {
        window.location.href = "/dashboard/manager";
      }, [3000]);
    }
  }, [updateState]);

  return (
    <div style={{ marginTop: "3.18rem" }}>
      <ToastContainer />

      <div style={styleColum1}>
        <p className="textPrimaryTableListAddStock">{t("information")}</p>

        <div style={styleRowInputs}>
          <InputSelectFilterManager
            disabled={editInventory}
            onChange={(e) => setTypeCount(e.target.value)}
            color="black"
            type={"typeCountage"}
            value={typeCount}
            custom={true}
            top={"43px"}
            width="295px"
            name={t("countType")}
          />
          <InputSelectFilterManager
            disabled={editInventory}
            onChange={(e) => setClient(e.target.value)}
            color="black"
            type="client"
            value={cliet}
            custom={true}
            top={"43px"}
            width="295px"
            name={t("client")}
          />
          <Input
            color="black"
            disabled={editInventory}
            onChange={(e) => setDeposit(e.target.value)}
            width="295px"
            value={deposit}
            marginLeft="8px"
            height="45px"
            name={t("deposit")}
          />
        </div>

        <div style={styleRowInputs}>
          <Input
            color="black"
            disabled={editInventory}
            onChange={(e) => setDescription(e.target.value)}
            type="text"
            value={description}
            name={t("description")}
            width="620px"
          />
          <Input
            color="black"
            disabled={editInventory}
            onChange={(e) => setProduct(e.target.value)}
            type="text"
            value={product}
            marginLeft="20px"
            name={t("barCode")}
            width="295px"
          />
        </div>

        <div style={styleRowInputs}>
          <Input
            color="black"
            disabled={""}
            type="text"
            onChange={(e) => setBatch(e.target.value)}
            value={batch}
            name={t("batch")}
            width="167.4px"
          />
          <Input
            color="black"
            disabled={editInventory}
            type="text"
            onChange={(e) => setSeries(e.target.value)}
            value={series}
            name={t("series")}
            width="167.4px"
            marginLeft="20px"
          />
          <Input
            color="black"
            disabled={""}
            type="text"
            mask={"99/99/9999"}
            onChange={(e) => setValidate(e.target.value)}
            value={validate}
            name={t("validity")}
            width="167.4px"
            marginLeft="20px"
          />
          <Input
            disabled={editInventory}
            onChange={(e) => setProductCode(e.target.value)}
            color="black"
            type="text"
            value={productCode}
            name={t("productCode")}
            width="167.4px"
            marginLeft="20px"
          />
          <Input
            color="black"
            type="text"
            disabled={editInventory}
            onChange={(e) => setManufacture(e.target.value)}
            value={manufacture}
            name={t("manufacture")}
            width="167.4px"
            marginLeft="20px"
            mask={"99/99/9999"}
          />
        </div>

        <div style={styleRowInputs}>
          <InputSelectFilterManager
            disabled={editInventory}
            onChange={(e) => setTypeStructure(e.target.value)}
            value={typeStructure}
            color="black"
            height={"51px"}
            top={"47px"}
            custom={true}
            type="typeStructure"
            name={t("typeStructure")}
            width="167.4px"
            marginLeft="0"
          />
          <InputSelectFilterManager
            disabled={editInventory}
            onChange={(e) => setTemperature(e.target.value)}
            color="black"
            height={"51px"}
            top={"47px"}
            custom={true}
            value={temperature}
            type="temperature"
            name={t("temperature")}
            width="167.4px"
          />
          <Input
            color="black"
            disabled={""}
            onChange={(e) => setAddress(e.target.value)}
            value={address}
            type="text"
            name={t("address")}
            width="167.4px"
          />
          <Input
            color="black"
            disabled={editInventory}
            onChange={(e) => setUnitaryValue(e.target.value)}
            value={unitaryValue}
            money={true}
            type="text"
            name={t("UnitaryValue")}
            width="167.4px"
            marginLeft="20px"
          />
          <Input
            color="black"
            disabled={editInventory}
            onChange={(e) => setInitialValue(e.target.value)}
            value={initialValue}
            type="text"
            name={t("InitialBalanceSystem")}
            width="167.4px"
            marginLeft="20px"
          />
        </div>

        {editInventory ? (
          <div style={styleRowInputs}>
            <Input
              color="black"
              disabled={""}
              onChange={(e) => setQuantity(e.target.value)}
              value={quantity}
              type="text"
              name={"Última Quantidade Registrada"}
              width="220px"
            />
          </div>
        ) : (
          <div style={styleRowInputs}>
            <Input
              color="black"
              disabled={""}
              onChange={(e) => setQuantity(e.target.value)}
              value={quantity}
              type="text"
              name={"Registrar contagem atual"}
              width="190px"
            />
          </div>
        )}
      </div>

      <div style={styleColum2}>
        <p className="textPrimaryTableListAddStock">
          {t("commentsAndPictures")}
        </p>

        <div style={styleRowInputs}>
          <InputSelectFilterManager
            value={reasons}
            type="errorreason"
            onChange={(e) => setReasons(e.target.value)}
            color="black"
            custom={true}
            top={"43px"}
            width="295px"
            name={t("reasonErrors")}
          />
        </div>

        <div style={styleRowInputs}>
          <Textarea
            value={comentarys}
            color="black"
            type="text"
            onChange={(e) => setComentarys(e.target.value)}
            name={t("comments")}
            width="99%"
            height="109px"
          />
        </div>

        <input
          onChange={(e) => getImages(e.target.files[0])}
          style={{ display: "none" }}
          type="file"
          id="file"
          name="file"
          accept="image/png,image/jpeg"
        />

        <label htmlFor="file" style={{ cursor: "pointer", width: "99%" }}>
          <img src={uploadFileIcon} style={{ width: "99%" }} />
        </label>

        <div style={{ display: "flex" }}>
          {imagesBase64.map((item) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "3rem",
                  marginLeft: "0.7rem",
                }}
              >
                <img
                  src={
                    item?.image == undefined
                      ? item
                      : "data:image/;base64;" + item.image
                  }
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "3px",
                    marginTop: "32px",
                  }}
                />

                <img
                  src={deleteImageIcon}
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "-10px",
                    background: "white",
                    zIndex: "1px",
                    borderRadius: "30px",
                    cursor: "pointer",
                  }}
                  onClick={() => removeImage(item.image, item)}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div></div>
        <button
          className="textBtnTableListStock"
          onClick={() => update()}
          style={btnStyle}
        >
          Editar
        </button>
      </div>
    </div>
  );
};

export default TableListEditStock;
